/* Dansk katalog for locale-projects-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'pj.tab.time': 'Tidsregistrering',
  'pj.tab.overview': 'Oversigt',
  'pj.tab.settings': 'Indstillinger',
  'pj.day.mon': 'Man',
  'pj.day.tue': 'Tir',
  'pj.day.wed': 'Ons',
  'pj.day.thu': 'Tor',
  'pj.day.fri': 'Fre',
  'pj.day.sat': 'Lør',
  'pj.day.sun': 'Søn',
  'pj.person.fallback': 'dig',
  'pj.time.title': 'Tidsregistrering for {name}',
  'pj.week.label': 'Uge {week}',
  'pj.week.word': 'Uge',
  'pj.week.pick': 'Vælg uge',
  'pj.week.current': 'Denne uge',
  'pj.week.back': 'Tre uger tilbage',
  'pj.week.forward': 'Tre uger frem',
  'pj.week.prev': 'Forrige uge',
  'pj.week.next': 'Næste uge',
  'pj.month.prev': 'Forrige måned',
  'pj.month.next': 'Næste måned',
  'pj.month.entries': 'Registrerede timer i {month}',
  'pj.month.dayHours': '{hours} registreret',
  'pj.view.day': 'Dag',
  'pj.view.week': 'Uge',
  'pj.day.empty': 'Ingen timer registreret denne dag.',
  'pj.table.projectActivity': 'Projekt / aktivitet',
  'pj.table.sum': 'Sum',
  'pj.table.hours': 'Timer',
  'pj.row.new': 'Ny række',
  'pj.row.add': 'Tilføj',
  'pj.row.remove': 'Fjern rækken',
  'pj.row.pickBoth': 'Vælg projekt og aktivitet',
  'pj.select.project': 'Vælg projekt …',
  'pj.select.activity': 'Vælg aktivitet …',
  'pj.select.projectSearch': 'Søg efter projekt …',
  'pj.select.activitySearch': 'Søg efter aktivitet …',
  'pj.select.projectEmpty': 'Ingen projekter matcher søgningen.',
  'pj.select.activityEmpty': 'Ingen aktiviteter matcher søgningen.',
  'pj.project.createAction': 'Opret nyt projekt',
  'pj.activity.createAction': 'Opret ny aktivitet',
  'pj.activity.none': 'Projektet har ingen aktiviteter endnu. Opret en her.',
  'pj.lock.state.done': 'Tidsregistreringen er registreret som færdig til og med {date}.',
  'pj.lock.state.open': 'Tidsregistreringen er ikke registreret som færdig',
  'pj.lock.markWeek': 'Marker som færdig til og med uge {week}',
  'pj.lock.undo': 'Fortryd',
  'pj.lock.done': 'Tidsregistreringen er markeret som færdig til og med uge {week}',
  'pj.lock.undone': 'Tidsregistreringen er genåbnet',
  'pj.entry.newTitle': 'Ny tidsregistrering',
  'pj.entry.editTitle': 'Rediger tidspost',
  'pj.entry.invoicedLocked': 'Timerne er faktureret og kan ikke ændres. Slet eller krediter fakturaudkastet for at frigive dem.',
  'pj.entry.periodLocked': 'Tidsregistreringen for denne periode er markeret som færdig.',
  'pj.entry.invoicedShort': 'Faktureret',
  'pj.field.project': 'Projekt',
  'pj.field.activity': 'Aktivitet',
  'pj.field.hours': 'Antal timer',
  'pj.field.date': 'Dato',
  'pj.field.description': 'Beskrivelse',
  'pj.field.descriptionHint': 'Hvad gik timerne til? Teksten kommer med på fakturaen.',
  'pj.field.name': 'Navn',
  'pj.field.number': 'Nummer',
  'pj.field.customer': 'Kunde',
  'pj.field.contact': 'Kontaktperson',
  'pj.field.optional': 'Valgfrit',
  'pj.field.defaultActivity': 'Standardaktivitet',
  'pj.field.product': 'Produkt',
  'pj.field.rate': 'Timepris',
  'pj.field.start': 'Start',
  'pj.field.end': 'Slut',
  'pj.field.color': 'Farve',
  'pj.field.status': 'Status',
  'pj.overview.title': 'Timeoversigt',
  'pj.overview.week': 'Ugeoversigt',
  'pj.overview.month': 'Månedsoversigt',
  'pj.overview.reports': 'Rapporter',
  'pj.overview.total': 'Sum registreret',
  'pj.overview.billable': '{hours} fakturerbart',
  'pj.overview.weekEntries': 'Registrerede timer i uge {week}',
  'pj.overview.empty': 'Ingen timer registreret i perioden',
  'pj.overview.emptyTitle': 'Ingen timer',
  'pj.filter.all': 'Alle',
  'pj.filter.period': 'Tidsrum',
  'pj.filter.billing': 'Fakturering',
  'pj.filter.billable': 'Fakturerbar',
  'pj.filter.nonBillable': 'Ikke',
  'pj.filter.invoicedLabel': 'Faktureret',
  'pj.filter.invoiced': 'Faktureret',
  'pj.filter.open': 'Ufaktureret',
  'pj.report.title': 'Registrerede timer {from} – {to}',
  'pj.report.emptyTitle': 'Ingen registreringer',
  'pj.report.emptyText': 'Ingen timer i den valgte periode og filter.',
  'pj.report.print': 'Udskriv',
  'pj.report.pdf': 'Download som PDF',
  'pj.report.pdfTitle': 'Timerapport',
  'pj.report.pdfError': 'Kunne ikke downloade rapporten.',
  'pj.report.pdfUnavailable': 'Rapport-PDF er ikke koblet til backend.',
  'pj.report.opening': 'Åbner udskrift …',
  'pj.basis.title': 'Faktureringsgrundlag',
  'pj.basis.projectName': 'Projektnavn',
  'pj.basis.searchPlaceholder': 'Projekt, kunde …',
  'pj.basis.summary': '{count} ufakturerede registreringer fra {from} til {to}',
  'pj.basis.selected': 'Valgt',
  'pj.basis.costs': 'Udlæg til viderefakturering',
  'pj.basis.costText': 'Udlæg',
  'pj.basis.costSource': 'Kilde',
  'pj.basis.costAmount': 'Beløb',
  'pj.basis.costEmployee': 'Medarbejderudlæg · {name}',
  'pj.basis.costPurchase': 'Bogført køb',
  'pj.basis.timesheet': 'Lav timeseddel som bilag',
  'pj.basis.create': 'Opret fakturaudkast',
  'pj.basis.created': 'Fakturaudkast oprettet for {project}',
  'pj.basis.pickOne': 'Vælg mindst én registrering',
  'pj.basis.error': 'Kunne ikke oprette fakturaudkastet.',
  'pj.basis.emptyTitle': 'Ingen ufakturerede timer',
  'pj.basis.emptyText': 'Alt er faktureret, eller der er endnu ikke registreret fakturerbare timer på projekter med kunde.',
  'pj.cost.tab': 'Udlæg',
  'pj.cost.title': 'Udlæg på projekt',
  'pj.cost.party': 'Ansat / leverandør',
  'pj.cost.voucher': 'Bilag',
  'pj.cost.openVoucher': 'Se bilag',
  'pj.cost.noVoucher': 'Bilaget er ikke tilgængeligt',
  'pj.cost.noVoucherHelp': 'Omkostningen har ingen fil tilknyttet.',
  'pj.cost.noVoucherShort': 'Uden bilag',
  'pj.cost.pending': 'Til godkendelse',
  'pj.cost.invoiced': 'Faktureret',
  'pj.cost.notBillable': 'Ikke fakturerbar',
  'pj.cost.toInvoice': 'Til fakturering',
  'pj.cost.searchLabel': 'Søg',
  'pj.cost.searchPlaceholder': 'Beskrivelse, ansat, leverandør …',
  'pj.cost.openSum': '{amount} til fakturering',
  'pj.cost.totalAll': 'Sum af alle resultater',
  'pj.cost.emptyTitle': 'Ingen udlæg',
  'pj.cost.emptyText': 'Ingen omkostninger er koblet til et projekt endnu. Bilag knyttes til projekt i indbakken, på købet eller når den ansatte indsender udlægget.',
  'pj.billing.always': 'Altid',
  'pj.billing.ask': 'Spørg',
  'pj.billing.never': 'Aldrig',
  'pj.activity.newTitle': 'Ny aktivitet',
  'pj.activity.editTitle': 'Rediger aktivitet',
  'pj.activity.namePlaceholder': 'F.eks. Konsulentbistand',
  'pj.activity.noProduct': 'Ingen',
  'pj.activity.productHint': 'Timerne faktureres som «{product}» og bogføres på konto {account}.',
  'pj.activity.noProductHint': 'Uden produkt bogføres timerne som tjenestesalg på konto 3020 med standardmomssats.',
  'pj.activity.rateHint': 'Ekskl. moms. Er feltet tomt, bruges prisen på produktet.',
  'pj.activity.neverHint': 'Timerne holdes uden for faktureringsgrundlaget. Brug dette til ferie og internt arbejde.',
  'pj.project.newTitle': 'Opret nyt projekt',
  'pj.project.newShort': 'Nyt projekt',
  'pj.project.editTitle': 'Rediger projekt',
  'pj.project.numberHint': 'Forslag: {number}',
  'pj.project.customerHint': 'Uden kunde kan timerne ikke faktureres.',
  'pj.project.noCustomer': 'Ingen kunde (internt projekt)',
  'pj.project.closed': 'Afsluttet',
  'pj.settings.title': 'Indstillinger for tidsregistrering',
  'pj.settings.activities': 'Aktiviteter',
  'pj.settings.projects': 'Projekter',
  'pj.settings.noActivitiesTitle': 'Ingen aktiviteter endnu',
  'pj.settings.noActivitiesText': 'Aktiviteten bestemmer timepris og hvilket produkt timerne faktureres som.',
  'pj.settings.noProjectsFirst': 'Opret et projekt først.',
  'pj.settings.noProjectsTitle': 'Ingen projekter endnu',
  'pj.settings.noProjectsText': 'Opret et projekt for at begynde at registrere timer.',
  'pj.toast.entrySaved': 'Timerne er registreret',
  'pj.toast.entryUpdated': 'Tidsposten er opdateret',
  'pj.toast.entryDeleted': 'Tidsposten er slettet',
  'pj.toast.activitySaved': 'Aktiviteten er gemt',
  'pj.toast.activityDeleted': 'Aktiviteten er slettet',
  'pj.toast.projectSaved': 'Projektet er gemt',
  'pj.toast.projectDeleted': 'Projektet er slettet',
  'pj.error.saveEntry': 'Kunne ikke gemme tidsposten.',
  'pj.error.deleteEntry': 'Kunne ikke slette tidsposten.',
  'pj.error.saveRows': 'Kunne ikke opdatere rækkerne.',
  'pj.error.lock': 'Kunne ikke opdatere låsen.',
  'pj.error.saveActivity': 'Kunne ikke gemme aktiviteten.',
  'pj.error.deleteActivity': 'Kunne ikke slette aktiviteten.',
  'pj.error.saveProject': 'Kunne ikke gemme projektet.',
  'pj.error.deleteProject': 'Kunne ikke slette projektet.',
  'pj.validation.projectName': 'Projektet skal have et navn.',
  'pj.validation.endBeforeStart': 'Slutdatoen kan ikke ligge før startdatoen.',
  'pj.validation.activityName': 'Aktiviteten skal have et navn.',
  'pj.validation.activityProject': 'Aktiviteten skal høre til et projekt.',
  'pj.validation.entryDate': 'Tidsposten skal have en dato.',
  'pj.validation.entryHours': 'Antal timer skal være større end 0.',
  'pj.validation.entryHoursMax': 'Én registrering kan ikke være mere end 24 timer.',
  'pj.validation.entryNotFound': 'Tidsposten blev ikke fundet.',
  'pj.validation.entryInvoiced': 'Tidsposten er allerede faktureret og kan ikke ændres.',
  'pj.validation.periodLocked': 'Tidsregistreringen for denne periode er markeret som færdig.',
  'svc.projectNotFound': 'Projektet blev ikke fundet.',
  'svc.projectNumberTaken': 'Projektnummeret er allerede i brug.',
  'svc.projectHasHours': 'Projektet har registrerede timer. Marker det som afsluttet i stedet for at slette det.',
  'svc.projectClosed': 'Projektet er afsluttet og kan ikke få nye timer.',
  'svc.projectNeedsCustomer': 'Projektet skal have en kunde, før timerne kan faktureres.',
  'svc.activityNotFound': 'Aktiviteten blev ikke fundet.',
  'svc.activityHasHours': 'Aktiviteten har registrerede timer og kan ikke slettes.',
  'svc.timeEntryNotFound': 'Tidsposten blev ikke fundet.',
  'svc.timeTrackingLocked': 'Tidsregistreringen for denne periode er markeret som færdig.',
  'svc.pickTimeEntries': 'Vælg mindst én ufaktureret tidsregistrering.',
  'svc.timesheetInvoiceDescription': 'Timer på {project} i perioden {from} – {to}.',
});
